import {
  ACCOUNT_ACTION,
  MAIN_PROFILE_ACTION,
  PURCHASE_TIER_ACTION
} from '../../constants/actions'

const changeAccountState = (property, value) => ({
  type: ACCOUNT_ACTION.CHANGE_STATE,
  payload: {
    property,
    value
  }
})

const changeAccountInputAndErrorState = (property, value) => ({
  type: ACCOUNT_ACTION.CHANGE_INPUT_AND_ERROR_STATE,
  payload: {
    property,
    value
  }
})

const refreshKYCInfo = () => ({
  type: ACCOUNT_ACTION.REFRESH_KYC
})

const resetAccountState = () => ({
  type: ACCOUNT_ACTION.RESET_STATE
})

const updateUserAccount = (userAttributes) => ({
  type: ACCOUNT_ACTION.ON_UPDATE_USER_ACCOUNT,
  payload: userAttributes
})

const resetPreviousUserPoints = () => ({
  type: MAIN_PROFILE_ACTION.RESET_PREVIOUS_USER_POINTS_STATE
})

const purchaseTierWithPoints = (tier) => ({
  type: PURCHASE_TIER_ACTION.WITH_POINTS,
  payload: {
    tier
  }
})

const changePurchaseTierState = (property, value) => ({
  type: PURCHASE_TIER_ACTION.CHANGE_STATE,
  payload: {
    property,
    value
  }
})

export {
  changeAccountState,
  changeAccountInputAndErrorState,
  refreshKYCInfo,
  resetAccountState,
  updateUserAccount,
  resetPreviousUserPoints,
  purchaseTierWithPoints,
  changePurchaseTierState
}
